export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte geben Sie einen neuen Namen für das Asset an"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dieser Name wird Ihnen helfen, die Wallet in Ihrer Asset-Liste leichter zu identifizieren."])}
}